import styled from 'styled-components';

export const PageTitle = styled.h1`
  color: var(--page-header-color);
  font-size: 1.5rem;
  font-weight: 600;
`;
